interface Suggestion {
  label: string;
  value: string;
}

const getAddressDataFromMagicKeys = async (
  magicKeys: string[]
): Promise<any> => {
  if (magicKeys.length === 0) return [];

  const promises = magicKeys.map((magicKey) => {
    const params = new URLSearchParams({ f: "json", magicKey });
    const geocodingUrl = `https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/findAddressCandidates?${params}`;
    return fetch(geocodingUrl)
      .then((res) => res.json())
      .then((data) => {
        return data.candidates[0] || null;
      });
  });
  const results = await Promise.all(promises);
  console.log("Magic key results:", results);
  return results;
};

export { getAddressDataFromMagicKeys };
